<template>
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" fill="currentcolor" clip-rule="evenodd" d="M0.608521 0.108459H0.108521V0.608459V3.65931H1.10852V1.10846H11.0916V3.65931H12.0916V0.608459V0.108459H11.5916H0.608521ZM11.5916 12.0915H12.0916V11.5915V8.54065H11.0916V11.0915L1.10857 11.0915L1.10857 8.54065H0.10857L0.10857 11.5915L0.10857 12.0915H0.60857L11.5916 12.0915ZM2.54922 8.54066V3.04913H3.54922V8.54066H2.54922ZM8.65092 3.04913V8.54066H9.65092V3.04913H8.65092ZM6.82036 8.54066V3.65931H7.82036V8.54066H6.82036ZM5.37966 7.9305V4.26948H4.37966V7.9305H5.37966Z" />
  </svg>
</template>

<script>
export default {
  name: 'ProductNumberIcon'
}
</script>

<style scoped>

</style>
